import * as React from 'react';
// @ts-ignore
import CurrencyInput from 'react-currency-input';
import {IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";

interface PriceInputProps extends IVirtualizedTableCellComponentProps {
}

interface PriceInputState {
    value: string | undefined;
}

export default class PriceInput extends React.Component<PriceInputProps, PriceInputState> {
    constructor(props: PriceInputProps) {
        super(props);

        this.state = {
            value: undefined
        };
    }

    componentDidMount() {
        this.setState({value: this.props.value});
    }

    componentDidUpdate(prevProps: PriceInputProps, prevState: PriceInputState) {
        const propsValue = this.props.value || "";
        const prevPropsValue = prevProps.value || "";
        if (this.state.value !== propsValue && this.props.readOnly)
            this.setState({value: propsValue});
        else if (propsValue !== prevPropsValue && this.state.value !== propsValue)
            this.setState({value: propsValue});
    }

    private saveChange = () => {
        this.props.onChange(this.state.value);
    }

    public render() {
        return (
            <div className="ui fluid input">
                <CurrencyInput
                    suffix={this.props.language === "en" ? " $" : " €"}
                    decimalSeparator={this.props.language === "en" ? "." : ","}
                    thousandSeparator={this.props.language === "en" ? "," : "."}
                    disabled={this.props.readOnly}
                    value={this.state.value === undefined || this.state.value === "" ? undefined : parseFloat(this.state.value) / 100}
                    onChangeEvent={(event: any, maskedvalue: any, floatvalue: any) => {
                        this.setState({value: (floatvalue * 100).toString()});
                    }}
                    onBlur={this.saveChange}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/PriceInput.tsx